// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffPreferredName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="preferredName"
      label="Preferred Name"
      rules={[
        {
          required: true,
          message: "Please input Preferred Name",
        },
        {
          whitespace: true,
          message: "Don't leave a blank character",
        },
      ]}
    >
      <Input placeholder="Please input Preferred Name" disabled={disabled} />
    </Form.Item>
  );
};

export default StaffPreferredName;
